module.exports = __webpack_public_path__ + "src/assets/img/door_left_back_color.c12970df.svg";